import styled from "@emotion/styled";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { ITextAreaFieldProps, TextAreaField } from "@livechat/design-system";

import TextAreaAutosizeField from "components/TextAreaAutosizeField";

export interface IProps {
  name: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event?: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event?: React.FocusEvent<HTMLTextAreaElement>) => void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
function shouldDisplayError(meta: any) {
  return meta.submitFailed || (meta.touched && !meta.pristine && meta.error);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const TextAreaFieldFinalForm = React.forwardRef<
  HTMLTextAreaElement,
  React.PropsWithRef<FieldRenderProps<string, HTMLTextAreaElement> & ITextAreaFieldProps>
>(({ input, meta, ...otherProps }, ref) => (
  <TextAreaField ref={ref} {...input} error={shouldDisplayError(meta) ? meta.error : undefined} {...otherProps} />
));

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const TextAreaAutosizeFieldFinalForm = React.forwardRef<
  HTMLTextAreaElement,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  React.PropsWithRef<FieldRenderProps<string, HTMLTextAreaElement> & any>
>(({ input, meta, ...otherProps }, ref) => (
  <TextAreaAutosizeField
    ref={ref}
    {...input}
    error={shouldDisplayError(meta) ? meta.error : undefined}
    {...otherProps}
  />
));

// works fine as long as you don't need to pass a ref
export const TextAreaFieldFullWidthFinalForm = styled(TextAreaFieldFinalForm)`
  textarea {
    resize: vertical;
    min-height: 2.5em;
  }
`;

// this solution is needed because of problems with the way emotion typings and passing refs work
export const TextAreaFieldFullWidthWrapper = styled.div`
  textarea {
    resize: vertical;
    min-height: 2.5em;
    width: 100%;
  }
`;
